import React from 'react';
import { Badge } from 'react-bootstrap';
import styles from './index.module.scss';

const CustomBadge = (props) => {
    const classes = [styles.CustomBadge];
    if(props.className) {
        classes.push(props.className);
    }

    switch (props.status) {
        case 'in_wait':
            return <Badge className={classes.join(" ")} variant="primary">En fila</Badge>;
        case 'ordered':
            return <Badge className={classes.join(" ")} variant="secondary">Ordenado</Badge>;
        case 'time':
            return <Badge className={classes.join(" ")} variant="dark">{props.time}</Badge>;
        case 'repairing':
            return <Badge className={classes.join(" ")} variant="dark">Reparando</Badge>;
        case 'ready':
            return <Badge className={classes.join(" ")} variant="info">Listo</Badge>;
        case 'failed':
            return <Badge className={classes.join(" ")} variant="warning">No Se Pudo</Badge>;
        case 'delivered':
            return <Badge className={classes.join(" ")} variant="success">Entregado</Badge>;
        case 'canceled':
            return <Badge className={classes.join(" ")} variant="danger">Cancelado</Badge>;
        default:
            return <Badge className={classes.join(" ")} variant="secondary">Unknown Status</Badge>
    }

};

export default CustomBadge;